import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// import { HistoricalPricesRoutingModule } from './historical-prices/historical-prices-routing.module';

const routes: Routes = [
  // { path: 'storico-quotazioni', loadChildren: './historical-prices/historical-prices.module#HistoricalPricesModule' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts